import React from 'react';
import PerformanceSummary from "../PerformanceSummary/performanceSummary";
import PerformanceSummaryLoader from "../common/loaders/PerformanceSummaryLoader";
import { useTranslations, useUserOverallPerformance } from "examsbook-react-sdk/custom-hooks";

/**
 * Overall performance report.
 */
function OverAllPerformance() {
    const t = useTranslations();
    const { overAllPerformanceData, isLoading } = useUserOverallPerformance();

    //render loader.
    function renderLoader() {
        return (
            <div className="loader-for-performance">
                <div className="loader-content">
                    <PerformanceSummaryLoader/>
                </div>
            </div>
        );
    }

    //render list.
    function renderList() {
        let performanceArray = [];
        if (overAllPerformanceData) {
            performanceArray.push({
                value: overAllPerformanceData.correct,
                outOf: overAllPerformanceData.totalQuestion,
                title: t('correct'),
                icon: 'fa fa-trophy',
                background: '#4388DE'
            });
            performanceArray.push({
                value: overAllPerformanceData.incorrect,
                outOf: overAllPerformanceData.totalQuestion,
                title: t('incorrect'),
                icon: 'fa fa-star',
                background: '#21B3B3'
            }, {
                value: (overAllPerformanceData.accuracy ? overAllPerformanceData.accuracy.toFixed(2) : 0) + '%',
                title: t('accuracy'),
                icon: 'fa fa-assistive-listening-systems',
                background: '#00CD79'
            }, {
                value: overAllPerformanceData.attempted,
                outOf: overAllPerformanceData.totalQuiz,
                title: t('COMPLETED_TEST'),
                icon: 'fa fa-sticky-note-o',
                background: '#7C6BD4'
            });
        }
        return (
            <div className="performance-show">
                {
                    performanceArray.map((data, key) => {
                        return (
                            <PerformanceSummary {...data} key={key}/>
                        );
                    })
                }
            </div>
        );
    }

    return (
        <React.Fragment>
            {
                !isLoading ? renderList() : renderLoader()
            }
        </React.Fragment>
    );
}

export default OverAllPerformance;
